// extracted by mini-css-extract-plugin
export default {"container":"styles_container__eQosU","cardContainer":"styles_cardContainer__gyk8A","largeCard":"styles_largeCard__QXcj8","column":"styles_column__FOimG"};